// @see https://github.com/mo/abortcontroller-polyfill-examples/blob/master/create-react-app-msie11/src/index.js
import "promise-polyfill/src/polyfill";
import "unfetch/polyfill";
import "abortcontroller-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { CookiesProvider } from "react-cookie";
import { parse as parseQueryString } from "query-string";

import FrontendApp from "./App";
import { DrupalSettingsContextProvider } from "./lib/DrupalSettings";

const initialiseApp = () => {
  const initQuery = parseQueryString(window.location.search);
  const root = document.getElementById("root");
  if (root) {
    /* eslint-disable no-console */
    console.log("Starting React app.");
    /* eslint-enable no-console */
    ReactDOM.render(
      <CookiesProvider>
        <DrupalSettingsContextProvider>
          <FrontendApp initQuery={initQuery} />
        </DrupalSettingsContextProvider>
      </CookiesProvider>,
      root
    );
  } else {
    /* eslint-disable no-console */
    console.error("React root node not found.");
    /* eslint-enable no-console */
  }
};

window.addEventListener(
  "load",
  () => {
    let count = 0;
    const interval = setInterval(() => {
      if (window.React && window.ReactDOM && window.ReactRouterDOM) {
        /* eslint-disable no-console */
        console.log(`Initialising after ${count}`);
        /* eslint-enable no-console */
        clearInterval(interval);
        initialiseApp();
      } else {
        count += 1;
        if (count >= 60) {
          /* eslint-disable no-console */
          console.error("Waited 30 secs for CDN libraries.");
          /* eslint-enable no-console */
          clearInterval(interval);
        }
      }
    }, 500);
  },
  false
);
